export default __webpack_public_path__ + "static/media/data_visualisation.9baa8d6a.svg";